// Native details provides keyboard activation and its expanded state without dependencies.
(() => {
  // Barra superior: un mensaje por vez. Sin JS se ve el primero; con «reducir movimiento», también.
  const rotate = () => document.querySelectorAll('[data-pk-announce]').forEach((bar) => {
    const items = [...bar.querySelectorAll('.pk-announce__item')];
    if (items.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches || bar.dataset.running) return;
    bar.dataset.running = '1';
    let i = 0, paused = false;
    bar.addEventListener('mouseenter', () => { paused = true; });
    bar.addEventListener('mouseleave', () => { paused = false; });
    const secs = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--pk-announce-speed')) || 4;
    setInterval(() => {
      if (paused) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, secs * 1000);
  });
  rotate();
  document.addEventListener('shopify:section:load', rotate);
  if (window.pkNavigationReady) return;
  window.pkNavigationReady = true;
  const desktop = window.matchMedia('(min-width: 1100px)');
  const syncMenus = () => document.querySelectorAll('[data-pk-navigation]').forEach((menu) => {
    menu.open = desktop.matches;
  });
  syncMenus();
  desktop.addEventListener('change', syncMenus);
  // Celular: el panel del menú arranca justo debajo del header, esté o no visible la barra superior.
  document.addEventListener('toggle', (event) => {
    const menu = event.target;
    if (!menu.matches || !menu.matches('[data-pk-navigation]') || desktop.matches || !menu.open) return;
    const header = menu.closest('.pk-header');
    if (header) document.documentElement.style.setProperty('--pk-nav-top', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
  }, true);
  document.addEventListener('shopify:section:load', syncMenus);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openMenu = event.target.closest('.pk-header details[open]');
    if (!openMenu || (desktop.matches && openMenu.matches('[data-pk-navigation]'))) return;
    openMenu.open = false;
    openMenu.querySelector('summary').focus();
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.pk-header details[open]').forEach((menu) => {
      if (desktop.matches && menu.matches('[data-pk-navigation]')) return;
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
})();
